import { Button } from "react-bootstrap"

const ButtonExclusive = ({ isFullWidth }) => {
  return (
    <a href="https://wa.me/?phone=6285891101162&text=Halo%20min,%20Saya%20mau%20daftar" target="_blank" rel="noreferrer">
      <Button className={`font-xl fw-bold ${isFullWidth ? 'w-100' : ''}`} type="button">
        Register CNAF
      </Button>
    </a>
  )
}

export default ButtonExclusive